import { gql } from "@apollo/client";

export const OBTENER_FORMAS_CONTACTO = gql`
  query ObtenerFormasContacto($idEmpresa: ID!, $filter: String) {
    obtenerFormasContacto(idEmpresa: $idEmpresa, filter: $filter) {
      _id
      formaContacto
      idEmpresa
    }
  }
`;